import { RiskAction } from '@assess/shared/ontology-types';

import { IProgramPeriodRiskAction } from '../entity/program-period-config/risk/program-period-risk-action';

export const riskActionService = {
  addCustomLabels(configuredRiskActions?: IProgramPeriodRiskAction[]): IProgramPeriodRiskAction[] {
    return [RiskAction.Confirm, RiskAction.Deny, RiskAction.NoAction]
      .map((ra) => {
        const configuredMatch = configuredRiskActions?.find((cra) => cra.type === ra);
        if (configuredMatch) {
          return configuredMatch;
        }

        return undefined as any;
      })
      .filter((ra) => !!ra);
  },
};
